import { render, staticRenderFns } from "./DomainOwnerForm.vue?vue&type=template&id=6a066ac0&"
import script from "./DomainOwnerForm.vue?vue&type=script&lang=js&"
export * from "./DomainOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainOwnerForm.vue?vue&type=style&index=0&id=6a066ac0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports